import { NavLink } from 'react-router-dom';

import {
  IconGroupSvg,
  IconGymSvg,
  IconPieChartSvg,
  IconSettingsSvg,
} from '~/assets/icons';

import { Container } from './styles';

const MenuBottom = () => {
  return (
    <Container>
      <NavLink to="/professional/students">
        <IconGroupSvg />
      </NavLink>

      <NavLink to="/professional/manager">
        <IconGymSvg />
      </NavLink>

      <NavLink to="/professional/manager-report">
        <IconPieChartSvg />
      </NavLink>

      <NavLink to="/professional/settings">
        <IconSettingsSvg />
      </NavLink>
    </Container>
  );
};

export default MenuBottom;
